<template>
    <p>Hi! welcome to OmniH Membership</p>
</template>

<script>
export default {
    name: 'MyUser'
}
</script>